<template>
  <div class="thesis-practice-popper-preview">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog width="550px"
                    custom-class="thesis-practice-popper-preview-dialog"
                    title="开题报告表单预览"
                    :visible.sync="visible">
      <div class="preview-main">
        <AppScrollbar v-if="subjects.length" style="height: 100%">
          <div class="subject-item" v-for="(subject, index) in subjects" :key="index">
            <div class="subject-title">
              <div class="name">{{subject.subject || subject.fieldName}}</div>
              <div class="role">{{subject.roleType === 'student' ? '学生' : '教师'}}</div>
            </div>
            <div class="subject-tip" v-if="subject.fieldName === '论文研究方向'">
              1、需为中文;2、每个研究方向限15个汉字以内，限填两个研究方向，以中文分号":"分隔;3、论文研究方向不能与专业名称相同;
            </div>
            <div class="subject-input">
              <template v-if="subject.fieldTypeCode === 'text'">
                <el-input type="textarea" :readonly="true" :rows="4"></el-input>
              </template>
              <template v-else-if="subject.fieldTypeCode === 'checkbox'">
                <el-checkbox :disabled="true" v-for="(item, index) in subject.fieldItem" :key="index">{{item}}</el-checkbox>
              </template>
              <template v-if="subject.fieldTypeCode === 'radio'">
                <el-radio v-model="radio" :disabled="true" v-for="(item, index) in subject.fieldItem" :key="index">{{item}}</el-radio>
              </template>
            </div>
          </div>
        </AppScrollbar>
        <template v-else>
          <Hint type="empty">
            <div>暂无可预览的表单项</div>
          </Hint>
        </template>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import Hint from '../../../../../../../elements/Hint'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
export default {
  name: 'ThesisPracticePopperPreview',
  components: {
    Hint,
    AppScrollbar,
    DataGridDialog
  },
  props: {
    inputSubjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      radio: ''
    }
  },
  computed: {
    subjects () {
      if (this.inputSubjects.length) {
        return this.inputSubjects.filter(subject => subject.checked).sort((a, b) => a.ascNum - b.ascNum)
      }
      return []
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="scss">
.thesis-practice-popper-preview{
  display: inline-block;
}
.thesis-practice-popper-preview-dialog{
  .preview-main{
    height: 500px;
    padding: 20px 0;
    overflow-y: auto;
    .subject-item{
      padding: 0 20px;
      font-size: 12px;
      & + .subject-item{
        margin-top: 20px;
      }
      & > .subject-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > .name{
          color: #303133;
          font-weight: bold;
        }
      }
      & > .subject-tip{
        margin-top: 5px;
      }
      & > .subject-input{
        margin-top: 15px;
        .el-checkbox__label,
        .el-radio__label{
          font-size: 12px;
        }
      }
    }
  }
}
</style>
